import { combineReducers } from "redux"
import alertReducer from "./alertReducer"
import dashboardReducer from "./dashboardReducer"
import deviceReducer from "./deviceReducer"
import deviceUpdateReducer from "./deviceUpdateReducer"
import featuresReducer from "./featuresReducer"
import groupReducer from "./groupReducer"
import integrationReducer from "./integrationReducer"
import internalReducer from "./internalReducer"
import modelMarketplaceReducer from "./modelMarketplaceReducer"
import modelReducer from "./modelReducer"
import otaMessageReducer from "./otaMessageReducer"
import userInfoSqlReducer from "./userInfoSqlReducer"
import userInsightsReducer from "./userInsightsReducer"
import userReducer from "./userReducer"

const allReducers = combineReducers({
  user: userReducer,
  device: deviceReducer,
  feature: featuresReducer,
  group: groupReducer,
  userInsights: userInsightsReducer,
  marketplace: modelMarketplaceReducer,
  userInfoSql: userInfoSqlReducer,
  model: modelReducer,
  userIntegrations: integrationReducer,
  internal: internalReducer,
  deviceUpdates: deviceUpdateReducer,
  alerts: alertReducer,
  dashboard: dashboardReducer,
  ota: otaMessageReducer,
})

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    return allReducers(undefined, action)
  }

  return allReducers(state, action)
}

export default rootReducer
